// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashboardHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    color: var(--primary_color);
    text-transform: capitalize;
    padding: 1rem 2rem 1rem 2rem;
}
.DashboardHeader_right{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 1rem;
    color: var(--primary_color);
}
.notification_icon {
    position: relative;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.dot {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: -10%;
    width: 12px;
    height: 12px;
    padding: 0.3rem;
    border-radius: 50%;
    background-color: var(--primary_color);
    color: white;
    font-size: 10px;
    -webkit-user-select: none;
            user-select: none;

}

.avatar {
    height: 2rem;
    width: 2rem;
    color: var(--white);
    background-color: var(--primary_color);
    border-radius: 50%;
    font-size: 1rem;
    font-weight: 700;
    -webkit-user-select: none;
            user-select: none;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
}



.dashboard_container {
    padding: 0rem 2rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding-top: 1rem;


}

.date_control {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dash_heading {
    font-weight: 600;
    font-size: 1.125rem;
    line-height: 1.375rem;
}

.control_buttons {
    display: flex;
    gap: 1rem;
}

.RefreshData {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1.25rem !important;
    -webkit-user-select: none;
            user-select: none;
}

.activeFilter {
    border: none;
    outline: none;
    background-color: inherit;
    padding: 0.3rem;
    border-bottom: 2px solid var(--primary_color);
}

.deactive_filter {
    border: none;
    outline: none;
    background-color: inherit;
    padding: 0.3rem;
    border-bottom: 2px solid var(--gray);

}

.dashboard_box {
    position: relative;
    width: 100%;

}

.card_Box {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    flex-wrap: wrap;

}

.chart_row {
    display: flex;
    /* gap: 2rem; */
    width: 100%;
    gap: 2rem;

}

.chart_box {
    position: relative;
    height: 22rem;
    box-shadow: var(--box_shadow);
    border-radius: 15px;
    padding: 1rem 2rem;
    background-color: var(--db_Bg);
    width: 50%;
}
.chart_row_with_cards{
    position: relative;
    display: flex;
    /* height: 28rem; */
    box-shadow: var(--box_shadow);
    border-radius: 15px;
    padding: 1rem 2rem;
    background-color: var(--db_Bg);
    width: 50%;
}
.chart_box_with_cards{
    width: 65%;
    /* height: 28rem; */
}



/* setting button */
.SettingBtn {
    font-size: 2rem;
    color: var(--primary_color);
    padding: .5rem;
    border-radius: 50%;
    background-color: white;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 2rem;
    bottom: 1rem;
    transition: all 1s;
    box-shadow: 0px 1px 25px rgba(0, 0, 0, 0.2);

}

.SettingBtn:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    background-color: var(--gray);
}

.avg_co2_card{
    display: flex;
    flex-direction: column;
    flex: 1 1;
    flex-shrink: 0;
    padding: 1rem;
    justify-content: center;
    align-items: center ;
    background-color: var(--light_gray);
}
.avg_co2_card>h6{
    font-size: 1rem;
    color: var(--gray);
}
.avg_co2_card>h5{
    font-size: 1rem;
    font-weight: 300;
    
}


.CombustibleCardsParent{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap:2rem;
    padding: 2rem 0rem;
    width: 100%;
}

.company_logo_container{
    width: 7rem;
    max-height: 7rem;
    overflow-y: hidden;
}

@media screen and (max-width: 1000px){

    .chart_box {
        position: relative;
        width: 100% !important;
    }

    .chart_row_with_cards{
        width: 100%;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
    }
    .chart_box_with_cards{
        width: 100%;
    }


    /* previous */

   
    .dashboard_container {
        padding: 0rem 2rem;
    }

    .date_control {
        flex-direction: column;
        gap: 2rem;
    }

    .card_Box {
        justify-content: center;
        flex-wrap: wrap;

    }


    .chart_row {
        flex-direction: column;
    }
    
    
    
}

@media screen and (max-width: 900px){
  
    .DashboardHeader {
        padding: 6rem 2rem 2rem 2rem;
    }
    .avg_co2_card{
        min-width: 50%;
    }
    .CombustibleCardsParent{
        flex-direction: column;
    }

    
}


@media screen and (max-width: 600px) {
    /* .DashboardHeader {
        padding: 1.4rem 0rem 1rem 1rem;
    } */

    .dashboard_container {
        padding: 0rem 1rem;
    }

    .date_control {
        gap: 1rem;
    }

    .control_buttons {
        flex-direction: column-reverse;
    }

    .card_Box {
        gap: 1rem;

    }
}

@media screen and (max-width: 365px) {

.DashboardHeader
{
    flex-direction: column-reverse;
}
}

`, "",{"version":3,"sources":["webpack://./src/Pages/ImpactPage/ImpactPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,sCAAsC;IACtC,YAAY;IACZ,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;;AAErB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,sCAAsC;IACtC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;;AAIA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;;;AAGrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,kCAAkC;IAClC,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,oCAAoC;;AAExC;;AAEA;IACI,kBAAkB;IAClB,WAAW;;AAEf;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,WAAW;IACX,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,SAAS;;AAEb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,UAAU;AACd;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;;;;AAIA,mBAAmB;AACnB;IACI,eAAe;IACf,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;;AAE/C;;AAEA;IACI,wCAAwC;IACxC,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAO;IACP,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,mCAAmC;AACvC;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;;AAEpB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,QAAQ;IACR,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;IACb;IACA;QACI,WAAW;IACf;;;IAGA,aAAa;;;IAGb;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,uBAAuB;QACvB,eAAe;;IAEnB;;;IAGA;QACI,sBAAsB;IAC1B;;;;AAIJ;;AAEA;;IAEI;QACI,4BAA4B;IAChC;IACA;QACI,cAAc;IAClB;IACA;QACI,sBAAsB;IAC1B;;;AAGJ;;;AAGA;IACI;;OAEG;;IAEH;QACI,kBAAkB;IACtB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,SAAS;;IAEb;AACJ;;AAEA;;AAEA;;IAEI,8BAA8B;AAClC;AACA","sourcesContent":[".DashboardHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n    color: var(--primary_color);\n    text-transform: capitalize;\n    padding: 1rem 2rem 1rem 2rem;\n}\n.DashboardHeader_right{\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 1rem;\n    color: var(--primary_color);\n}\n.notification_icon {\n    position: relative;\n    cursor: pointer;\n    user-select: none;\n}\n\n.dot {\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: -10%;\n    width: 12px;\n    height: 12px;\n    padding: 0.3rem;\n    border-radius: 50%;\n    background-color: var(--primary_color);\n    color: white;\n    font-size: 10px;\n    user-select: none;\n\n}\n\n.avatar {\n    height: 2rem;\n    width: 2rem;\n    color: var(--white);\n    background-color: var(--primary_color);\n    border-radius: 50%;\n    font-size: 1rem;\n    font-weight: 700;\n    user-select: none;\n    text-transform: uppercase;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n\n\n.dashboard_container {\n    padding: 0rem 2rem;\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n    padding-top: 1rem;\n\n\n}\n\n.date_control {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.dash_heading {\n    font-weight: 600;\n    font-size: 1.125rem;\n    line-height: 1.375rem;\n}\n\n.control_buttons {\n    display: flex;\n    gap: 1rem;\n}\n\n.RefreshData {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 1.25rem !important;\n    user-select: none;\n}\n\n.activeFilter {\n    border: none;\n    outline: none;\n    background-color: inherit;\n    padding: 0.3rem;\n    border-bottom: 2px solid var(--primary_color);\n}\n\n.deactive_filter {\n    border: none;\n    outline: none;\n    background-color: inherit;\n    padding: 0.3rem;\n    border-bottom: 2px solid var(--gray);\n\n}\n\n.dashboard_box {\n    position: relative;\n    width: 100%;\n\n}\n\n.card_Box {\n    display: flex;\n    justify-content: flex-start;\n    width: 100%;\n    flex-wrap: wrap;\n\n}\n\n.chart_row {\n    display: flex;\n    /* gap: 2rem; */\n    width: 100%;\n    gap: 2rem;\n\n}\n\n.chart_box {\n    position: relative;\n    height: 22rem;\n    box-shadow: var(--box_shadow);\n    border-radius: 15px;\n    padding: 1rem 2rem;\n    background-color: var(--db_Bg);\n    width: 50%;\n}\n.chart_row_with_cards{\n    position: relative;\n    display: flex;\n    /* height: 28rem; */\n    box-shadow: var(--box_shadow);\n    border-radius: 15px;\n    padding: 1rem 2rem;\n    background-color: var(--db_Bg);\n    width: 50%;\n}\n.chart_box_with_cards{\n    width: 65%;\n    /* height: 28rem; */\n}\n\n\n\n/* setting button */\n.SettingBtn {\n    font-size: 2rem;\n    color: var(--primary_color);\n    padding: .5rem;\n    border-radius: 50%;\n    background-color: white;\n    position: fixed;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    right: 2rem;\n    bottom: 1rem;\n    transition: all 1s;\n    box-shadow: 0px 1px 25px rgba(0, 0, 0, 0.2);\n\n}\n\n.SettingBtn:hover {\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    background-color: var(--gray);\n}\n\n.avg_co2_card{\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    flex-shrink: 0;\n    padding: 1rem;\n    justify-content: center;\n    align-items: center ;\n    background-color: var(--light_gray);\n}\n.avg_co2_card>h6{\n    font-size: 1rem;\n    color: var(--gray);\n}\n.avg_co2_card>h5{\n    font-size: 1rem;\n    font-weight: 300;\n    \n}\n\n\n.CombustibleCardsParent{\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap:2rem;\n    padding: 2rem 0rem;\n    width: 100%;\n}\n\n.company_logo_container{\n    width: 7rem;\n    max-height: 7rem;\n    overflow-y: hidden;\n}\n\n@media screen and (max-width: 1000px){\n\n    .chart_box {\n        position: relative;\n        width: 100% !important;\n    }\n\n    .chart_row_with_cards{\n        width: 100%;\n        flex-direction: column;\n        align-items: center;\n        gap: 1rem;\n    }\n    .chart_box_with_cards{\n        width: 100%;\n    }\n\n\n    /* previous */\n\n   \n    .dashboard_container {\n        padding: 0rem 2rem;\n    }\n\n    .date_control {\n        flex-direction: column;\n        gap: 2rem;\n    }\n\n    .card_Box {\n        justify-content: center;\n        flex-wrap: wrap;\n\n    }\n\n\n    .chart_row {\n        flex-direction: column;\n    }\n    \n    \n    \n}\n\n@media screen and (max-width: 900px){\n  \n    .DashboardHeader {\n        padding: 6rem 2rem 2rem 2rem;\n    }\n    .avg_co2_card{\n        min-width: 50%;\n    }\n    .CombustibleCardsParent{\n        flex-direction: column;\n    }\n\n    \n}\n\n\n@media screen and (max-width: 600px) {\n    /* .DashboardHeader {\n        padding: 1.4rem 0rem 1rem 1rem;\n    } */\n\n    .dashboard_container {\n        padding: 0rem 1rem;\n    }\n\n    .date_control {\n        gap: 1rem;\n    }\n\n    .control_buttons {\n        flex-direction: column-reverse;\n    }\n\n    .card_Box {\n        gap: 1rem;\n\n    }\n}\n\n@media screen and (max-width: 365px) {\n\n.DashboardHeader\n{\n    flex-direction: column-reverse;\n}\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
